@import '@hevoio/hevo-ui-toolkit/styles/variables';

.boxTable {
  > thead > tr {
    height: 60px !important;
  }

  tr {
    display: grid;
    grid-template-columns: 20% 20% 27% 33%;
  }

  td,
  th {
    display: flex;
    align-items: center;
  }
}

.noItemBoxIconContainer {
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  width: 60px;
  margin-bottom: $spacer;
  background-color: $primary;
}

.noItemBoxIcon {
  color: $light-text;
  font-size: 30px;
}
